import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { UserStore, UserState } from './user.store';

@Injectable({ providedIn: 'root' })
export class UserQuery extends Query<UserState> {

  userInfo$ = this.select();

  constructor(protected store: UserStore) {
    super(store);
  }

}
